angular.module('app')
    .controller('BlankCtrl', function($scope,$rootScope,$http,$location,$filter,HttpService,$sessionStorage,FactoryObj) {
    	$scope.disabled = false;
  
        $scope.test = function(){
          //alert("clicked!");
          $('#test').css('color','#f00');
        }
        
        $scope.change = function(){
          $scope.disabled = !$scope.disabled;
        }
        
        
    	
    })